import App from "./app";
import AppLoader from "./core/app.loader";

const appLoader = new AppLoader(App, {
    appName: "My Bundle Manager"
});